/**
 * MPLACE - QA (MP-5646).
 *
 * TEMPORARY, decided 2026-10-29: every URL here is deliberately IDENTICAL to
 * `environment.qa.ts`, so the Mplace theme can be exercised against the existing
 * Staftr QA backend before any Mplace infrastructure exists.
 *
 * Only the BRAND differs from `environment.qa.ts` - `title` and `favicon`. If
 * you are diffing the two files and find any other difference, that is a bug.
 *
 * When Mplace QA infrastructure lands, the three hosts below move to it. The
 * `stage` and `prod` siblings keep their REPLACE-ME placeholders on purpose:
 * a production build silently pointed at QA would be far worse than one that
 * fails to start.
 */
export const environment = {
    production: false,
    clientHost: 'https://qastaging.staftr.com/',
    apiUrl: 'https://qastaging.staftr.com/api/',
    adminAppUrl: 'https://adminqa.staftr.com/admin',
    tokenRefreshBefore: -2,
    dateFormat: 'MM/dd/yyyy',
    usSpecificTimezoneOnly: true,
    title: "Mplace",
    favicon: 'assets/images/favicon_mplace.png',
    firebaseConfig :{
        apiKey: "AIzaSyAr3j3zU9oZ7OYp6ITBBgnwKUoHrEVcm7M",
        authDomain: "mplace-dd342.firebaseapp.com",
        databaseURL: "https://mplace-qa.firebaseio.com",
        projectId: "mplace-dd342",
        storageBucket: "",
        messagingSenderId: "136536185534",
        logging: true
    },
    unitTestConfig: {
        defaultPassword: "Tester@1234"
    },
    isPWCEnabled: false,
    // MP-5646: the brand's root class and loader tint.
    // A brand that declares `brandClass` gets it on <html> and drives the
    // `{brand}-icon` class; one that declares none keeps the old two-brand
    // behaviour exactly, so staftr and pwc are untouched.
    brandClass: 'mplace',
    primaryColor: '#004267',
    // MP-5646: brand-profile values, read by HelperService.getLogo().
    // The legacy app's white wordmark, which reads correctly on the dark
    // slate (#596979) Mplace header.
    logo: 'assets/images/mp-logo-white.png',
    reportLogo: 'assets/images/m-logo.png',
    // 244x73 native (ratio 3.342). Keeps the ratio at a header-sized height;
    // the shared 127x62 box would squash it.
    logoWidth: 160,
    logoHeight: 48,
    // The LOGIN panel is white, so the white-knockout header logo would be
    // invisible there. This is Mplace's full-colour wordmark (`mpLogo` in the
    // legacy app config): orange M, navy 'place'.
    loginLogo: 'assets/images/mp-logo.png',
    // The login panel's background is a looping video in the live Mplace app
    // (`stage.mp4` behind the landing/login form). Served from a BRAND-SCOPED
    // assets folder that only the mplace build configurations include, so the
    // 9 MB file never reaches a staftr or pwc bundle.
    loginPanelVideo: 'assets/brand/stage.mp4',
    mailToContact: 'info@mplace.io',
    privacyPolicyUrl: 'https://staftr.com/privacy-policy/',
    termsOfServiceUrl: 'https://staftr.com/terms-of-use/'
};
